import { Box, Typography } from "@mui/material";

export default function MobileLocationPage(){
    return(
    <Box
        sx={{mt:"70px"}}
    >
        <iframe 
            title="Fyki Fyki Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3148.573224666102!2d24.0119954!3d37.8936622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a18f02bc06fa9b%3A0x243cb18dd0f81c26!2sFyki-Fyki!5e0!3m2!1sen!2sgr!4v1749186694335!5m2!1sen!2sgr" 
            width="80%" 
            height="350" 
            style={{border:0}}
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
        </iframe>
        
        <Typography sx={{p:1}}>Leof. G. Gregou 45, Porto Rafti 190 03</Typography>
    </Box>);
}